import { observable } from 'mobx';
import { getFisOrBopisFeatureFlagStatus } from '../../utils';
import { checkStoreAvailability, IFindInStoreState } from './findInStoresUtils';

export const findInStoreState = observable<IFindInStoreState>({
  enabled: getFisOrBopisFeatureFlagStatus('fis'),
  storesData: null,
  storesDataError: null,
  async fetchStoresData(sku: string) {
    const findInStoreInputs = {
      sku: sku,
      limit: 10,
    };
    if (this.storesData) this.storesData = null; // Reset the storesData to show the loading state inside the sidebar
    const response = await checkStoreAvailability(findInStoreInputs);
    if ('detail' in response) {
      if (response.detail.toLowerCase() === 'location is unknown') return;
      this.storesDataError = response;
    } else {
      if (this.storesDataError) this.storesDataError = null;
      this.storesData = response;
    }
  },
});
